import {
  IconArbeitUndWirtschaft,
  IconDigitalisierung,
  IconEnergie,
  IconGlobaleVerantwortung,
  IconLebenUndWohnen,
  IconMobilitaetUndInfrastruktur,
  IconPartizipationUndTeilhabe,
  IconUmweltUndRessourcenschutz,
  IconWetterUndKlima,
  IconWissenschaft,
} from '@/components/Icons/ActionFields'

export const ActionFieldsIconMap = {
  'arbeit-und-wirtschaft': IconArbeitUndWirtschaft,
  digitalisierung: IconDigitalisierung,
  energie: IconEnergie,
  'globale-verantwortung': IconGlobaleVerantwortung,
  'leben-und-wohnen': IconLebenUndWohnen,
  'mobilitaet-und-infrastruktur': IconMobilitaetUndInfrastruktur,
  'partizipation-und-teilhabe': IconPartizipationUndTeilhabe,
  'umwelt-und-ressourcenschutz': IconUmweltUndRessourcenschutz,
  'wetter-und-klima': IconWetterUndKlima,
  wissenschaft: IconWissenschaft,
}
